<ngx-spinner type="ball-scale-multiple" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#39B4E2">

        <h1 style="color: #FFF" class="pt-3 poppins-medium">Finalizando...</h1>
</ngx-spinner>

<div class="cronometro p-2 text-center   d-flex h-100 align-items-center pt-3"
    style="background-color: rgba(255, 0, 0, 0.825);">
    <i class="i-Clock roboto-bold ps-2" style="font-size: 34px;"></i>
    <div>
        <h1 class="roboto-bold">00:{{ minutos | number: '2.0' }}:{{ segundos | number: '2.0' }} </h1>
        <h4>Últimas unidades disponíveis, garanta já antes de acabar o estoque</h4>
    </div>

</div>
<div class=" p-3">
    <div class="card col-12 pb-2 px-3" style="border-top: 1rem solid rgba(255, 0, 0, 0.825);">
        <div class="mb-3">
            <h1 class="pt-3 poppins-medium">Resumo do pedido</h1>
            <div class="d-flex mt-4 gap-3 ps-3">
                <div style="width: 6rem; height: 6rem; border-radius: 12%; overflow: hidden;">
                    <img src="../../../../assets/images/fire-1unidade.jpeg" alt="Imagem" style="width: 100%; height: 100%; object-fit: contain;">
                  </div>
                <div class="mt-1">
                    <h5 class="poppins-medium">FIRE BIG</h5>
                    <p class="poppins-medium">1 unidade(s)</p>
                </div>
            </div>

        </div>


    </div>

    <form [formGroup]="formCliente" (ngSubmit)="submitForm($event)">
        <div class="card col-12 pb-4 mt-3 px-3">
            <h1 class="pt-3 ">Suas informações</h1>
            <label class="pb-1 mt-3">Nome completo:</label>
            <input  formControlName="nome" name="nome" id="nome" [ngClass]="{'is-invalid': campoInvalido(formCliente, 'nome')}" class="form form-control form-control-lg" type="text" />
            <div *ngIf="campoInvalido(formCliente, 'nome')" class="invalid-feedback d-block">
                Preencha esse campo, obrigatório!
              </div>
          
                
                
            <label class="pb-1 mt-3">CPF:</label>
            <input formControlName="cpf" [ngClass]="{'is-invalid': campoInvalido(formCliente, 'cpf')}" class="form form-control form-control-lg" type="text" />
            <div *ngIf="campoInvalido(formCliente, 'cpf')" class="invalid-feedback d-block">
                Preencha esse campo, obrigatório!
              </div>
            <label class="pb-1 mt-3">Telefone/Whatsapp:</label>
            <input formControlName="phone" [ngClass]="{'is-invalid': campoInvalido(formCliente, 'phone')}" class="form form-control form-control-lg" type="text" />
            <div *ngIf="campoInvalido(formCliente, 'phone')" class="invalid-feedback d-block">
                Preencha esse campo, obrigatório!
              </div>
        </div>

        <div class="card col-12 pb-4 mt-3 px-3">
            <h1 class="pt-3 mt-3">Endereço e entrega</h1>
            <label class="pb-1">CEP:</label>
            <input name="cep" [ngClass]="{'is-invalid': campoInvalido(formCliente, 'endereco.cep')}" id="cep" formControlName="cep" (input)="buscarCep($event.target.value)" class="form form-control form-control-lg"
                type="text" />
                <div *ngIf="campoInvalido(formCliente, 'endereco.cep')" class="invalid-feedback d-block">
                    Preencha esse campo, obrigatório!
                  </div>

            <div formGroupName="endereco" *ngIf="controllerCep">
                <label class="pb-1 mt-3">Rua:</label>
                <input formControlName="logradouro" [ngClass]="{'is-invalid': campoInvalido(formCliente, 'endereco.logradouro')}"  class="form form-control form-control-lg" type="text" />
                <div *ngIf="campoInvalido(formCliente, 'endereco.logradouro')" class="invalid-feedback d-block">
                    Preencha esse campo, obrigatório!
                  </div>

                <label class="pb-1  mt-3">Bairro:</label>
                <input formControlName="bairro" [ngClass]="{'is-invalid': campoInvalido(formCliente, 'endereco.bairro')}"  class="form form-control form-control-lg" type="text" />
                <div *ngIf="campoInvalido(formCliente, 'endereco.bairro')" class="invalid-feedback d-block">
                    Preencha esse campo, obrigatório!
                  </div>
                <label class="pb-1 mt-3">Localidade:</label>
                <input formControlName="localidade" [ngClass]="{'is-invalid': campoInvalido(formCliente, 'endereco.localidade')}" class="form form-control form-control-lg" type="text" />
                <div *ngIf="campoInvalido(formCliente, 'endereco.localidade')" class="invalid-feedback d-block">
                    Preencha esse campo, obrigatório!
                  </div>
                <label class="pb-1 mt-3">Estado:</label>
                <input formControlName="estado" [ngClass]="{'is-invalid': campoInvalido(formCliente, 'endereco.estado')}" class="form form-control form-control-lg" type="text" />
                <div *ngIf="campoInvalido(formCliente, 'endereco.estado')" class="invalid-feedback d-block">
                    Preencha esse campo, obrigatório!
                  </div>
                <div class="d-flex gap-2 mt-3">
                    <div class="col-6"> <label class="pb-1">Número:</label>
                        <input formControlName="numero" [ngClass]="{'is-invalid': campoInvalido(formCliente, 'endereco.numero')}" class="form form-control form-control-lg" type="text" />
                        <div *ngIf="campoInvalido(formCliente, 'endereco.numero')" class="invalid-feedback d-block">
                            Preencha esse campo, obrigatório!
                          </div>
                    </div>
                    <div class="col-6"> <label class="pb-1">Complemento:</label>
                        <input formControlName="complemento"  class="form form-control form-control-lg"
                            type="text" />
                    </div>
                </div>
                <label class="pb-1 mt-3">Informações adicionais deste endereço</label>
                <textarea formControlName="obs"  class="form form-control form-control-lg mb-4"></textarea>

            </div>

        </div>


        <ngb-alert class="alert-card mt-5" [type]="alert.type" *ngFor="let alert of alertCards">
            <strong class="text-capitalize">{{alert.message}}</strong>
        </ngb-alert>


        <div (click)="eventS(1)" *ngIf="sss" class="card col-12 roboto-regular   " style="border: 2px solid green">
            <div class="d-flex gap-3 pt-3 mt-3 px-3">
                <label class="checkbox checkbox-success">
                    <input type="checkbox" checked>
                    <span class="checkmark"></span>
                </label>
                <h3 class="poppins-regular">🚨 OFERTA EXCLUSIVA 🚨</h3>
            </div>
            <div class="d-flex mt-4 gap-3 pb-3 ps-3">
                <div style="width: 10rem; height: 6rem; border-radius: 12%; overflow: hidden;">
                    <img src="../../../../assets/images/fire-2unidades.jpeg" alt="Imagem" style="width: 100%; height: 100%; object-fit: contain;">
                  </div>
                <div class="mt-1 ps-1">
                    <h5 class="poppins-medium">BIG FIRE EXTRA</h5>
                    <p class="poppins-medium">+ 1 unidade extra</p>
                    <small class="poppins-medium">Acelere seu resultado e tenha um pênis duro e enorme em poucos meses
                    </small>
                </div>
            </div>
            <div class="text-center">
                <p class="poppins-medium" style="color: red;">OBS: Levando 2 frascos o frete é GRÁTIS</p>
            </div>

        </div>
        <div (click)="eventS(2)" *ngIf="!sss" class="card col-12 roboto-regular  "
            style="border: 2px solid rgba(255, 0, 0, 0.825);">
            <div class="d-flex gap-3 pt-3 mt-3 px-3">
                <label class="checkbox checkbox-danger">
                    <input type="checkbox" [(ngModel)]="controllerOrder" >
                    <span class="checkmark"></span>
                </label>
                <h3 class="poppins-regular">🚨 OFERTA EXCLUSIVA 🚨</h3>
            </div>
            <div class="d-flex mt-4 gap-3 pb-3 ps-3">

                <div style="width: 10rem; height: 6rem; border-radius: 12%; overflow: hidden;">
                    <img src="../../../../assets/images/fire-2unidades.jpeg" alt="Imagem" style="width: 100%; height: 100%; object-fit: contain;">
                  </div>

                <div class="mt-1 ps-1">
                    <h5 class="poppins-medium">BIG FIRE</h5>
                    <p class="poppins-medium">+ 1 unidade extra</p>
                    <small class="poppins-medium">Acelere seu resultado e tenha um pênis duro e enorme em poucos meses
                    </small>
                </div>
            </div>
            <div class="text-center">
                <p class="poppins-medium" style="color: red;">OBS: Levando 2 frascos o frete é GRÁTIS</p>
            </div>

        </div>


        <div class="card mt-4 p-3 poppins-extralight">
            <div class="d-flex justify-content-between">
                <h5>Valor pedido:</h5>
                <h5>R$ {{valorPedido}},00 </h5>
            </div>
            <div class="d-flex justify-content-between poppins-regular">
                <h5>Valor frete:</h5>
                <h5>{{freteTela}}</h5>
            </div>

            <div class="d-flex justify-content-between  poppins-medium pt-2">
                <h1>Valor total:</h1>
                <h1>R$ {{valor}},00 </h1>
            </div>
            <button class="btn mt-4 btn-success w-100 p-3 text-white" type="submit"><strong>FINALIZAR
                    PEDIDO!</strong></button>
        </div>

    </form>

</div>
<div class="text-center card p-5">
    <div class="text-center pb-4"><svg xmlns="http://www.w3.org/2000/svg" style="color: green;" width="60" height="60"
            fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
            <path
                d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
        </svg></div>
    <h5>Ficou com alguma dúvida?</h5>
    <p>Entre em contato com nossa equipe</p>
    <button class="btn text-white btn-success">FALAR COM NOSSA EQUIPE</button>
</div>

<ng-template #modalSmall let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">AVISO IMPORTANTE</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p>Confirmo que farei o pagamento assim que o produto chegar na minha casa.</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success text-white " (click)="redirectToSuccessPage()">SIM CONCORDO!</button>
    </div>
</ng-template>